export default __webpack_public_path__ + "static/media/ring.b3b621c4.svg";